module.exports = __webpack_public_path__ + "img/settings-2_640.a67927f0.webp";